import { hrefOf } from '../overview/href'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import {
  agentDiscoveryListQuery,
  agentDiscoveryQuery,
  saveAgentDiscoveryKind,
  saveAgentDiscoveryUsers,
  scanAgentDiscovery,
  type AgentDiscoveryCommand,
  type AgentDiscoveryDevice,
  type AgentSettingsTab,
  type DeviceAgentDiscoveryList,
  type DeviceAgentDiscoveryPage,
} from '../api/devices'
import { toast } from '../ui/notify'
import { SettingsCheck } from '../ui/SettingsParts'
import { Spinner } from '../ui/Spinner'

/**
 * Fila Discovery - discoverySettings.php: banda discoveryList (Devices /
 * Open Ports / Extended Discovery / Users). Listele sunt devicesSettings.php,
 * servicesSettings.php, extendedSettings.php si usersSettings.php. Identify /
 * Add unmanaged / Clean / Add by hand raman in portalul vechi.
 *
 * CAPUL TABELULUI STA IN CURGERE (18 septembrie 2026). Fila se deschide in
 * fisa de sub randul listei de aparate, adica in `td.rowDetails` INAUNTRUL
 * `table.dataTable` al listei. `src/v4.css` lipeste capul listei cu
 * `body.tk-list-flush #page-content table.dataTable thead th { position:
 * sticky; top: 45px }` - legaturi de descendenta, deci apuca orice `th` de sub
 * lista, si pe al nostru. Exceptia de acolo pentru fisa deschisa cere
 * `table.dataTable` si pe tabelul dinauntru; `nd-found-table` nu-l are. Iar
 * tabelul sta in `.nd-log-body` (`overflow: auto`): acela devenea derulatorul
 * de care se lipea capul, si capul se desena cu 45px mai jos de marginea lui -
 * peste "Nothing discovered yet on this machine." si peste primul rand, pe
 * toate filele cu tabel. Nu bifa din cap (26.9.18.20): 26.9.18.19 iese la fel.
 * Regula de mai jos, (1,2,5) fata de (1,2,4), pune capul inapoi in curgere -
 * `relative`, ca exceptia din `v4.css`, fiindca pe el sta manerul de latime
 * din `list_chrome.css`. Tine si tabelul de bannere din randul desfacut.
 */

const ND_CSS = `.nd-log-body{max-height:640px;overflow:auto}
.nd-log-col .nd-scan{margin:0 10px 0 4px}
.nd-log-col .panel-heading.sm{display:flex;align-items:center;gap:10px}
.nd-log-col .panel-heading.sm h4{margin:0}
.nd-head-count{margin-left:auto;color:#8a94a0;font-size:12px;font-weight:400}
.nd-found-table th,.nd-found-table td{font-size:12px;vertical-align:middle}
.nd-found-table th.nd-sort{cursor:pointer;white-space:nowrap;-webkit-user-select:none;user-select:none}
.nd-found-table th.nd-sort:hover{color:#33414e;background:#f4f6f8}
.nd-found-table th.nd-sort.is-on{color:#33414e}
.nd-found-table th.nd-sort .fas{margin-left:3px;color:#8a94a0}
body.tk-list-flush #page-content .nd-log-body table>thead>tr>th{position:relative;top:auto;z-index:auto}
.nd-status{display:flex;flex-wrap:wrap;align-items:center;gap:8px;padding:0 0 12px;font-size:13px;border-bottom:1px solid #eee;margin-bottom:8px}
.nd-status.is-busy{color:#1a73e8}
.nd-status.is-ok{color:#3c763d}
.nd-status.is-err{color:#a94442}
.nd-status .when{color:#8a94a0;font-size:12px}
.nd-status .out{flex:1 0 100%;margin:6px 0 0;font-size:12px;color:#555;white-space:pre-wrap}
.nd-empty{color:#8a94a0;padding:16px 8px}
.nd-list-tools{display:inline-flex;align-items:stretch;margin-left:8px}
.nd-list-tools .nd-search{width:160px;height:28px;border-top-right-radius:0;border-bottom-right-radius:0}
.nd-filter-wrap{position:relative}
.nd-filter-btn{height:28px;width:32px;padding:0;border-top-left-radius:0;border-bottom-left-radius:0;margin-left:-1px;position:relative}
.nd-filter-badge{position:absolute;top:-5px;right:-5px;min-width:14px;height:14px;line-height:14px;font-size:10px;background:#1a73e8;color:#fff;border-radius:8px;padding:0 4px}
.nd-filter-pop{position:absolute;right:0;top:100%;z-index:30;min-width:220px;max-height:280px;overflow:auto;background:#fff;border:1px solid #ddd;box-shadow:0 4px 12px rgba(0,0,0,.12);padding:8px 10px;margin-top:4px}
.nd-filter-pop .grp{font-size:11px;color:#8a94a0;margin:8px 0 4px;text-transform:uppercase}
.nd-filter-pop .grp:first-child{margin-top:0}
.nd-filter-pop .nd-filter-opt{font-size:12px;margin:0 0 3px}
.nd-chip{display:inline-block;font-size:11px;line-height:18px;background:#eef3f8;color:#7b8794;border-radius:10px;padding:0 8px;margin:0 3px 3px 0;white-space:nowrap}
.nd-chip.has-banner{background:#e7f4ea;color:#1f7a4d;font-weight:600}
.nd-svc-list{display:flex;flex-direction:column;gap:1px}
.nd-svc{display:flex;align-items:baseline;gap:8px;min-width:0}
.nd-svc .nd-chip{flex:0 0 auto;margin:1px 0;min-width:56px;text-align:center}
.nd-svc-resp{flex:1 1 auto;min-width:0;max-width:640px;font-family:Menlo,Monaco,Consolas,monospace;font-size:11px;color:#55606b;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.nd-svc-quiet{display:flex;flex-wrap:wrap;margin-top:3px}
.nd-chevron{cursor:pointer;color:#8a94a0;width:22px;text-align:center}
.nd-chevron:hover{color:#333}
tr.nd-open td{background:#f7fafc}
.nd-host{font-weight:600}
.nd-host-meta{color:#8a94a0;font-size:11px;margin-bottom:6px}
.nd-banner-table{margin:0}
.nd-banner-table th{font-size:11px;color:#8a94a0;font-weight:600}
.nd-banner-table td{font-size:12px}
.nd-banner-empty{color:#8a94a0;padding:8px}
.nd-banner-table .nd-resp{word-break:break-all;font-family:Menlo,Monaco,Consolas,monospace;font-size:11px}
.nd-log-col .nd-identify{margin-left:6px}
.nd-head{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
.nd-head h4{margin:0}
.nd-head .pushDiscoverCommand{margin-left:auto}`

export function DeviceAgentDiscovery({ id }: { id: number }) {
  const page = useQuery(agentDiscoveryQuery(id))
  if (page.error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {page.error.message}
      </div>
    )
  }
  if (!page.data) return <Spinner />
  return <Band page={page.data} />
}

function Band({ page }: { page: DeviceAgentDiscoveryPage }) {
  const first = page.tabs[0]?.key ?? 'devices'
  const [active, setActive] = useState(first)
  const current = page.tabs.find((t) => t.key === active) ?? page.tabs[0]

  return (
    <div className="row">
      <style>{ND_CSS}</style>
      <div className="col-md-12">
        <ul className="nav nav-tabs line-tabs mb-2 discoveryList" role="tablist">
          {page.tabs.map((tab) => (
            <li key={tab.key} className={tab.key === active ? 'active' : undefined}>
              <a
                href={hrefOf(`${tab.href}${page.device.id}`) ?? '#'}
                onClick={(e) => {
                  e.preventDefault()
                  setActive(tab.key)
                }}
              >
                <i className={tab.icon}></i> {tab.label} <Badge tab={tab} />
              </a>
            </li>
          ))}
        </ul>
        <div className="tab-content discovery-settings-pane">
          {current?.key === 'users' ? (
            <Users id={page.device.id} />
          ) : current ? (
            <FoundList id={page.device.id} kind={current.key} />
          ) : null}
        </div>
      </div>
    </div>
  )
}

function Badge({ tab }: { tab: AgentSettingsTab }) {
  if (tab.badge === null || tab.badge === '') return null
  return (
    <span className={`tab-badge tab-badge-${tab.badgeTone}`} title={tab.badgeTitle}>
      {tab.badge}
    </span>
  )
}

function FoundList({ id, kind }: { id: number; kind: string }) {
  const mode = kind === 'ports' ? 'services' : kind
  const list = useQuery(agentDiscoveryListQuery(id, mode))
  if (list.error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {list.error.message}
      </div>
    )
  }
  if (!list.data) return <Spinner />
  return <FoundPane page={list.data} mode={mode} />
}

function FoundPane({ page, mode }: { page: DeviceAgentDiscoveryList; mode: string }) {
  const query = useQueryClient()
  const devices = page.devices ?? []
  const commands = page.commands ?? []
  const [search, setSearch] = useState('')
  const [sort, setSort] = useState<Sort>({ key: '', dir: 1 })
  const [types, setTypes] = useState<string[]>([])
  const [makers, setMakers] = useState<string[]>([])
  const [filterOpen, setFilterOpen] = useState(false)
  const [openRows, setOpenRows] = useState<Record<number, boolean>>({})
  const [scanning, setScanning] = useState(false)
  const scanned = commands.length > 0 || devices.length > 0
  const latest = commands[0]
  const busy = scanning || (!!latest && (latest.state === 'queued' || latest.state === ''))
  const showDetail = (mode === 'services' || mode === 'extended') && (devices.some((d) => (d.port_details?.length ?? 0) > 0) || busy)

  const shown = useMemo(() => {
    const q = search.trim().toLowerCase()
    let rows = devices.filter((d) => {
      if (types.length && !types.includes(d.type || '')) return false
      if (makers.length && !makers.includes(d.manufacturer || '')) return false
      if (!q) return true
      return [d.name, d.ip, d.mac, d.manufacturer, d.type, d.seen, d.ports].some((v) => String(v ?? '').toLowerCase().includes(q))
    })
    const key = sort.key
    if (key !== '') {
      rows = [...rows].sort((a, b) => cmp(a, b, key) * sort.dir)
    }
    return rows
  }, [devices, search, types, makers, sort])

  const typeOptions = unique(devices.map((d) => d.type).filter(Boolean))
  const makerOptions = unique(devices.map((d) => d.manufacturer).filter(Boolean))
  const filterCount = types.length + makers.length

  const scan = async () => {
    setScanning(true)
    try {
      await scanAgentDiscovery(page.device.id, mode)
      toast(mode === 'devices' ? 'Scanning now.' : 'Command sent!', 'Success')
      await query.invalidateQueries({ queryKey: ['device', page.device.id, 'agent-settings', 'discovery'] })
    } catch {
      toast(mode === 'devices' ? 'The scan could not be started.' : 'An error ocured!', 'Error', 'error')
    } finally {
      setScanning(false)
    }
  }

  const leftover = () => toast('Identify, add and clean still open the current portal.', 'Info', 'info')

  const title =
    mode === 'extended' ? (
      <>
        <strong>Extended</strong> Discovery
      </>
    ) : mode === 'services' ? (
      <>
        <strong>Open</strong> Ports
      </>
    ) : (
      <strong>Devices</strong>
    )

  const empty = !devices.length
    ? busy
      ? mode === 'extended'
        ? 'Reading banners…'
        : showDetail
          ? 'Probing services…'
          : 'Looking for devices…'
      : 'Nothing discovered yet on this machine.'
    : !shown.length
      ? 'No devices match the search or filters.'
      : ''

  const count =
    !devices.length
      ? ''
      : shown.length !== devices.length
        ? `${shown.length} of ${devices.length} ${devices.length === 1 ? 'device' : 'devices'}`
        : `${devices.length} ${devices.length === 1 ? 'device' : 'devices'}`

  const split = mode !== 'devices'

  return (
    <div className={`row nd-layout${split ? ' is-split' : ''}`} data-device={page.device.id} data-mode={mode}>
      {split ? <SideSettings page={page} mode={mode} onPush={() => void scan()} pushing={scanning} /> : null}
      <div className={`nd-log-col ${split ? 'col-md-9' : 'col-md-12'}`}>
        <header className="panel-heading sm" data-color="theme-inverse">
          <h4 id="ndLogTitle">{title}</h4>
          <span className="nd-head-count" id="ndDeviceCount">
            {count}
          </span>
          {mode === 'devices' ? (
            <button type="button" className="btn btn-primary btn-sm nd-scan" onClick={() => void scan()} disabled={scanning}>
              <i className="fa fa-paper-plane"></i> {scanned ? 'Rescan' : 'Scan'}
            </button>
          ) : null}
          <div className="nd-list-tools">
            <input
              type="search"
              className="form-control input-sm nd-search"
              placeholder="Search"
              autoComplete="off"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="nd-filter-wrap">
              <button type="button" className="btn btn-default btn-sm nd-filter-btn" title="Filters" onClick={() => setFilterOpen((o) => !o)}>
                <i className="fas fa-filter"></i>
                {filterCount ? <span className="nd-filter-badge">{filterCount}</span> : <span className="nd-filter-badge" hidden></span>}
              </button>
              <div className="nd-filter-pop" hidden={!filterOpen}>
                {typeOptions.length ? (
                  <>
                    <div className="grp">Type</div>
                    {typeOptions.map((t) => (
                      <div key={t} className="nd-filter-opt">
                        <SettingsCheck checked={types.includes(t)} onChange={() => setTypes(toggle(types, t))} label={t} />
                      </div>
                    ))}
                  </>
                ) : null}
                {makerOptions.length ? (
                  <>
                    <div className="grp">Manufacturer</div>
                    {makerOptions.map((t) => (
                      <div key={t} className="nd-filter-opt">
                        <SettingsCheck checked={makers.includes(t)} onChange={() => setMakers(toggle(makers, t))} label={t} />
                      </div>
                    ))}
                  </>
                ) : null}
                {!typeOptions.length && !makerOptions.length ? <div className="grp">No filters yet</div> : null}
              </div>
            </div>
          </div>
          <button type="button" className="btn btn-default btn-xs nd-identify" title="Fill Type and Manufacturer from MAC, ports and banners" onClick={leftover}>
            Identify
          </button>
          {mode === 'devices' ? (
            <>
              <button type="button" className="btn btn-success btn-xs nd-unmanaged" title="Add the selected devices to the inventory, without an agent" onClick={leftover}>
                <i className="fas fa-plus"></i> Add as unmanaged
              </button>
              <button type="button" className="btn btn-default btn-xs nd-clean-selected" onClick={leftover}>
                Remove selected
              </button>
              <button type="button" className="btn btn-danger btn-xs nd-clean-all" onClick={leftover}>
                Clean all
              </button>
            </>
          ) : null}
        </header>
        {mode === 'devices' ? (
          <div className="panel-body nd-hand-wrap">
            <button type="button" className="btn btn-link btn-xs nd-hand-open" onClick={leftover}>
              <i className="fas fa-plus"></i> Add a device by hand
            </button>
          </div>
        ) : null}
        <div className="panel-body nd-log-body" id="ndScanLog">
          <StatusBar latest={latest} busy={busy} hasDevices={devices.length > 0} />
          <table className="table table-condensed table-hover nd-found-table" style={{ marginTop: 8 }}>
            <thead>
              <tr>
                {mode === 'extended' ? (
                  <>
                    <th style={{ width: 22 }}></th>
                    <SortHead label="Name" keyName="name" sort={sort} onSort={setSort} />
                    <SortHead label="IP" keyName="ip" sort={sort} onSort={setSort} />
                    <SortHead label="Type" keyName="type" sort={sort} onSort={setSort} />
                    {showDetail ? <SortHead label="Services" keyName="services" sort={sort} onSort={setSort} /> : null}
                  </>
                ) : mode === 'services' ? (
                  <>
                    <SortHead label="Discovered" keyName="seen" sort={sort} onSort={setSort} />
                    <SortHead label="MAC" keyName="mac" sort={sort} onSort={setSort} />
                    <SortHead label="IP" keyName="ip" sort={sort} onSort={setSort} />
                    <SortHead label="Name" keyName="name" sort={sort} onSort={setSort} />
                    {showDetail ? <SortHead label="Services" keyName="services" sort={sort} onSort={setSort} /> : null}
                  </>
                ) : (
                  <>
                    <th style={{ width: 28 }}>
                      <SettingsCheck className="nd-check-all" aria-label="Select all" />
                    </th>
                    <SortHead label="Name" keyName="name" sort={sort} onSort={setSort} />
                    <SortHead label="IP" keyName="ip" sort={sort} onSort={setSort} />
                    <SortHead label="MAC" keyName="mac" sort={sort} onSort={setSort} />
                    <SortHead label="Manufacturer" keyName="manufacturer" sort={sort} onSort={setSort} />
                    <SortHead label="Type" keyName="type" sort={sort} onSort={setSort} />
                    <SortHead label="When" keyName="seen" sort={sort} onSort={setSort} />
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {empty ? (
                <tr>
                  <td colSpan={mode === 'extended' ? (showDetail ? 5 : 4) : mode === 'services' ? (showDetail ? 5 : 4) : 7} className="nd-empty">
                    {empty}
                  </td>
                </tr>
              ) : (
                shown.map((row) => (
                  <DeviceRow
                    key={row.id || `${row.mac}-${row.ip}`}
                    row={row}
                    mode={mode}
                    showDetail={showDetail}
                    open={!!openRows[row.id]}
                    onToggle={() => setOpenRows((cur) => ({ ...cur, [row.id]: !cur[row.id] }))}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

/**
 * Recurenta scanarii de porturi / extinse - `servicesSettings.php` /
 * `extendedSettings.php`: bifa, "Every" (Day / Week / Month) si "At", salvate
 * pe tipul 3 / 4 din it_discovery_settings.
 */
function SideSettings({ page, mode, onPush, pushing }: { page: DeviceAgentDiscoveryList; mode: string; onPush(): void; pushing: boolean }) {
  const query = useQueryClient()
  const s = page.settings ?? { custom_filter: '', recurrence: false, recurrence_interval: 1, recurrence_moment: 1, recurrence_time: '' }
  const [recurrence, setRecurrence] = useState(s.recurrence)
  const [interval, setInterval] = useState(s.recurrence_interval)
  const [time, setTime] = useState(s.recurrence_time)
  const [saving, setSaving] = useState(false)
  const kind: 'services' | 'extended' = mode === 'extended' ? 'extended' : 'services'

  const save = async () => {
    setSaving(true)
    try {
      await saveAgentDiscoveryKind(page.device.id, kind, {
        device_unique: page.device.id,
        recurrence: recurrence ? 1 : 0,
        recurrence_interval: interval,
        recurrence_moment: s.recurrence_moment,
        recurrence_time: time,
      })
      toast('Saved.', 'Success')
      await query.invalidateQueries({ queryKey: ['device', page.device.id, 'agent-settings', 'discovery'] })
    } catch {
      toast('It could not be saved.', 'Error', 'error')
    } finally {
      setSaving(false)
    }
  }
  const heading = mode === 'extended' ? (
    <>
      <strong>Extended</strong> Discovery
    </>
  ) : (
    <>
      <strong>Open</strong> Ports
    </>
  )
  const help =
    mode === 'extended'
      ? 'Reads the banners of the open ports (SSH, HTTP, SMB…). Push now starts an extended scan; the Devices list stays as it is.'
      : 'Probes the TCP ports of the hosts found by Devices (SSH, HTTP, SMB, RDP, printers…). Push now rescans and refreshes the list; the banners in Extended stay as they are.'

  return (
    <div className="nd-settings col-md-3">
      <header className="panel-heading sm nd-head" data-color="theme-inverse">
        <h4>{heading}</h4>
        <button type="button" className="btn btn-primary btn-sm pushDiscoverCommand" onClick={onPush} disabled={pushing}>
          <i className="fa fa-paper-plane"></i> Push now
        </button>
      </header>
      <div className="panel-body">
        <p className="help-block" style={{ marginTop: 0 }}>
          {help}
        </p>
        <form
          className={`form-horizontal labelcustomize ${mode === 'extended' ? 'discoverExtended' : 'discoverServices'}`}
          data-collabel="3"
          data-alignlabel="left"
          data-label="color"
          onSubmit={(e) => {
            e.preventDefault()
            void save()
          }}
        >
          <input type="hidden" className="form-control" name="device_unique" value={page.device.id} required />
          <div className="form-group">
            <label style={{ textAlign: 'left' }} className="control-label col-md-3">
              <span className="color">Recurrence</span>
            </label>
            <div className="col-md-9">
              <div style={{ marginBottom: 20, marginTop: 10 }}>
                <SettingsCheck className="iCheckRecurrence" name="recurrence" value="1" checked={recurrence} onChange={setRecurrence} label="Activate Recurrence" />
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-group">
                    <span className="input-group-addon">Every</span>
                    <select className="form-control" name="recurrence_interval" value={interval} onChange={(e) => setInterval(Number(e.target.value))}>
                      <option value={1}>Day</option>
                      <option value={2}>Week</option>
                      <option value={3}>Month</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <span className="input-group-addon">At</span>
                    <input className="form-control timepicker" type="text" name="recurrence_time" value={time} onChange={(e) => setTime(e.target.value)} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group offset">
            <div className="col-md-offset-3 col-md-9">
              <button type="submit" className="btn btn-success" disabled={saving}>
                <i className="fa fa-check"></i> Save settings
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

function StatusBar({ latest, busy, hasDevices }: { latest?: AgentDiscoveryCommand; busy: boolean; hasDevices: boolean }) {
  if (busy) {
    return (
      <div className="nd-status is-busy">
        <i className="fa fa-spinner fa-spin"></i> <strong>Scanning the network…</strong>
        {hasDevices ? null : <span className="when">Waiting for the agent</span>}
        {latest?.output ? <div className="out">{latest.output}</div> : null}
      </div>
    )
  }
  if (latest?.state === 'error') {
    return (
      <div className="nd-status is-err">
        <i className="fa fa-times-circle"></i> <strong>Scan failed</strong>
        <span className="when">{latest.at}</span>
        {latest.output ? <div className="out">{latest.output}</div> : null}
      </div>
    )
  }
  if (latest && (latest.state === 'ok' || latest.state === 'sent')) {
    return (
      <div className="nd-status is-ok">
        <i className="fa fa-check-circle"></i> <strong>Scan finished</strong>
        <span className="when">{latest.at}</span>
        {latest.output ? <div className="out">{latest.output}</div> : null}
      </div>
    )
  }
  if (hasDevices) {
    return (
      <div className="nd-status">
        <strong>Last seen on this machine</strong>
      </div>
    )
  }
  return null
}

function DeviceRow({
  row,
  mode,
  showDetail,
  open,
  onToggle,
}: {
  row: AgentDiscoveryDevice
  mode: string
  showDetail: boolean
  open: boolean
  onToggle(): void
}) {
  if (mode === 'extended') {
    return (
      <>
        <tr className={open ? 'nd-open' : undefined} data-id={row.id}>
          <td className="nd-chevron" title="Show banners" onClick={onToggle}>
            <i className={`fas ${open ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
          </td>
          <td>
            <div className="nd-host">{row.name}</div>
            <div className="nd-host-meta">{row.mac}</div>
          </td>
          <td>{row.ip}</td>
          <td>{row.type}</td>
          {showDetail ? <td>{<Chips row={row} />}</td> : null}
        </tr>
        {open ? (
          <tr className="nd-open">
            <td colSpan={showDetail ? 5 : 4}>
              {row.port_details?.length ? (
                <table className="table table-condensed nd-banner-table">
                  <thead>
                    <tr>
                      <th>Port</th>
                      <th>Service</th>
                      <th>Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    {row.port_details.map((p, i) => (
                      <tr key={`${p.port}-${p.proto}-${i}`}>
                        <td>
                          {p.port}/{p.proto}
                        </td>
                        <td>{p.name}</td>
                        <td className="nd-resp">{p.banner || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="nd-banner-empty">No banners on this host.</div>
              )}
            </td>
          </tr>
        ) : null}
      </>
    )
  }
  if (mode === 'services') {
    return (
      <tr data-id={row.id}>
        <td>{row.seen}</td>
        <td>{row.mac}</td>
        <td>{row.ip}</td>
        <td>{row.name}</td>
        {showDetail ? (
          <td>
            <Chips row={row} />
          </td>
        ) : null}
      </tr>
    )
  }
  return (
    <tr data-id={row.id}>
      <td>
        <SettingsCheck className="nd-one" value={row.id} aria-label={`Select ${row.name}`} />
      </td>
      <td>{row.name}</td>
      <td>{row.ip}</td>
      <td>{row.mac}</td>
      <td>{row.manufacturer}</td>
      <td>{row.type}</td>
      <td>{row.seen}</td>
    </tr>
  )
}

function Chips({ row }: { row: AgentDiscoveryDevice }) {
  const talking = (row.port_details ?? []).filter((p) => p.banner)
  const quiet = (row.port_details ?? []).filter((p) => !p.banner)
  if (!talking.length && !quiet.length && row.services?.length) {
    return (
      <>
        {row.services.map((s) => (
          <span key={s} className="nd-chip">
            {s}
          </span>
        ))}
      </>
    )
  }
  return (
    <div className="nd-svc-list">
      {talking.map((p) => (
        <div className="nd-svc" key={`${p.port}-${p.proto}`}>
          <span className="nd-chip has-banner">
            {p.name || p.port}
          </span>
          <span className="nd-svc-resp" title={p.banner}>
            {p.banner}
          </span>
        </div>
      ))}
      {quiet.length ? (
        <div className="nd-svc-quiet">
          {quiet.map((p) => (
            <span key={`${p.port}-${p.proto}`} className="nd-chip">
              {p.name || p.port}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  )
}

function SortHead({
  label,
  keyName,
  sort,
  onSort,
}: {
  label: string
  keyName: SortKey
  sort: Sort
  onSort(next: Sort): void
}) {
  const on = sort.key === keyName
  return (
    <th
      className={`nd-sort${on ? ' is-on' : ''}`}
      onClick={() => onSort({ key: keyName, dir: on && sort.dir === 1 ? -1 : 1 })}
    >
      {label}
      {on ? <i className={`fas ${sort.dir === 1 ? 'fa-sort-up' : 'fa-sort-down'}`}></i> : null}
    </th>
  )
}

function Users({ id }: { id: number }) {
  const page = useQuery(agentDiscoveryListQuery(id, 'users'))
  if (page.error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {page.error.message}
      </div>
    )
  }
  if (!page.data) return <Spinner />
  return <UsersForm page={page.data} />
}

function UsersForm({ page }: { page: DeviceAgentDiscoveryList }) {
  const query = useQueryClient()
  const s = page.settings ?? {
    custom_filter: '',
    recurrence: false,
    recurrence_interval: 1,
    recurrence_moment: 1,
    recurrence_time: '',
  }
  const [filter, setFilter] = useState(s.custom_filter)
  const [recurrence, setRecurrence] = useState(s.recurrence)
  const [interval, setInterval] = useState(s.recurrence_interval)
  const [moment, setMoment] = useState(s.recurrence_moment)
  const [time, setTime] = useState(s.recurrence_time)
  const [busy, setBusy] = useState(false)

  const fields = (push: boolean) => ({
    custom_filter: filter,
    recurrence: recurrence ? 1 : 0,
    recurrence_interval: interval,
    recurrence_moment: moment,
    recurrence_time: time,
    ...(push ? { push_now: 1 } : {}),
  })

  const save = async (push: boolean) => {
    setBusy(true)
    try {
      await saveAgentDiscoveryUsers(page.device.id, fields(push))
      toast(push ? 'Command sent!' : 'Saved.', 'Success')
      await query.invalidateQueries({ queryKey: ['device', page.device.id, 'agent-settings', 'discovery'] })
    } catch {
      toast(push ? 'An error ocured!' : 'It could not be saved.', 'Error', 'error')
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <header className="panel-heading sm" data-color="theme-inverse">
        <h4>
          <strong>Get active directory</strong> users
        </h4>
        <label className="color">
          <i className="fas fa-info-circle"></i> This device is set as an <strong>Active Directory relay</strong>{' '}
        </label>
      </header>
      <div className="panel-body">
        <form
          className="form-horizontal labelcustomize discoverUsers"
          data-collabel="3"
          data-alignlabel="left"
          data-label="color"
          method="post"
          action="/discovery/saveDiscoverUsersSettings"
          onSubmit={(e) => {
            e.preventDefault()
            void save(false)
          }}
        >
          <input type="hidden" className="form-control" name="device_unique" value={page.device.id} required />
          <div className="form-group">
            <label style={{ textAlign: 'left' }} className="control-label col-md-3">
              <span className="color">Custom filter</span>
            </label>
            <div className="col-md-9">
              <input className="form-control" type="text" value={filter} name="custom_filter" onChange={(e) => setFilter(e.target.value)} />
              <span className="help-block">
                <i className="fas fa-info-circle"></i> Eg. LDAP://121.21.121.121/CN=Our Users,DC=AD,DC=CHOC,DC=ORG
              </span>
            </div>
          </div>
          <div className="form-group">
            <label style={{ textAlign: 'left' }} className="control-label col-md-3">
              <span className="color">Recurrence</span>
            </label>
            <div className="col-md-9">
              <div style={{ marginBottom: 20, marginTop: 10 }}>
                <SettingsCheck className="iCheckRecurrence" name="recurrence" value="1" checked={recurrence} onChange={setRecurrence} label="Activate Recurrence" />
              </div>
              <div className="input-group">
                <span className="input-group-addon">Every</span>
                <select className="form-control" name="recurrence_interval" value={interval} onChange={(e) => setInterval(Number(e.target.value))}>
                  <option value={1}>Day</option>
                  <option value={2}>Week</option>
                  <option value={3}>Month</option>
                </select>
                <span className="input-group-addon weekDayMoment" hidden={interval !== 2}>
                  On
                </span>
                <select
                  className="form-control weekDayMoment"
                  name="recurrence_moment"
                  hidden={interval !== 2}
                  disabled={interval !== 2}
                  value={moment}
                  onChange={(e) => setMoment(Number(e.target.value))}
                >
                  {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day, i) => (
                    <option key={day} value={i + 1}>
                      {day}
                    </option>
                  ))}
                </select>
                <span className="input-group-addon monthDayMoment" hidden={interval !== 3}>
                  On the
                </span>
                <select
                  className="form-control monthDayMoment"
                  name="recurrence_moment"
                  hidden={interval !== 3}
                  disabled={interval !== 3}
                  value={1}
                  onChange={() => setMoment(1)}
                >
                  {Array.from({ length: 31 }, (_, i) => i + 1).map((n) => (
                    <option key={n} value={1}>
                      {n}
                      {n === 1 ? 'st' : n === 2 ? 'nd' : n === 3 ? 'rd' : 'th'}
                    </option>
                  ))}
                </select>
                <span className="input-group-addon">At</span>
                <input className="form-control timepicker" type="text" name="recurrence_time" value={time} onChange={(e) => setTime(e.target.value)} />
              </div>
            </div>
          </div>
          <div className="form-group offset">
            <div className="col-md-offset-3 col-md-9">
              <button type="submit" className="btn btn-success" disabled={busy}>
                <i className="fa fa-check"></i> Save settings
              </button>{' '}
              <button type="button" className="btn btn-primary pushDiscoverCommand" disabled={busy} onClick={() => void save(true)}>
                <i className="fa fa-paper-plane"></i> Push command now
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

/** Capetele care se pot sorta in lista celor gasite. `services` e coloana lipita din porturi. */
type SortKey = 'name' | 'ip' | 'mac' | 'manufacturer' | 'type' | 'seen' | 'services'

/** Coloana apasata si sensul; cheia goala = lista in ordinea de la server. */
interface Sort {
  key: SortKey | ''
  dir: 1 | -1
}

function unique(values: string[]): string[] {
  return [...new Set(values)].sort((a, b) => a.localeCompare(b))
}

function toggle(list: string[], value: string): string[] {
  return list.includes(value) ? list.filter((v) => v !== value) : [...list, value]
}

function cell(d: AgentDiscoveryDevice, key: SortKey): string {
  return key === 'services' ? d.ports || d.services.join(' ') : d[key]
}

function cmp(a: AgentDiscoveryDevice, b: AgentDiscoveryDevice, key: SortKey): number {
  return cell(a, key).localeCompare(cell(b, key), undefined, { numeric: true, sensitivity: 'base' })
}
